import React, { useState, useEffect } from 'react';
import { Alert, Box, Card, CardContent, Grid, MenuItem, IconButton, Typography, TextField, Button } from '@mui/material';
import axios from 'axios';
import { token, apiUrl } from '../../../../../api';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../../services/api';

const ChannelDrawerCreate = ({ deal, onClose, onSaved }) => {
    const [form, setForm] = useState({
        name: '',
        type: '',
        external_id: ''
    });
    const [saving, setSaving] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [appId, setAppId] = useState(null);

    //  pegar app padrão
    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            setAppId(response.data.app.id);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        pegar_app_padrao();
    }, []);

    //  só busca user quando tiver appId
    useEffect(() => {
        if (!appId) return;
    }, [appId]);

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            name: form.name,
            type: form.type,
            external_id: form.external_id
        };

        try {
            const res = await api.post(`v1/apps/${appId}/channels/`, payload);
            // await axios.post(`${apiUrl}/api/channels/`, payload, {
            //     headers: { Authorization: token }
            // });
            if (res.data) {
                onSaved();
                onClose();
                setStatus({ type: 'success', message: 'Criado com sucesso!' });
            } else {
                setStatus({ type: 'error', message: 'Erro ao criar!' });
            }
        } catch (error) {
            setStatus({ type: 'error', message: 'Erro ao criar!' });
            console.error('Erro ao criar ticket:', error.response?.data || error);
        }
    };

    const deleteChannel = async () => {
        setSaving(true);
        try {
            const res = await api.delete(`v1/apps/${appId}/deals/${deal.id}/`);
            if (res.data) {
                onClose();
                setStatus({ type: 'error', message: 'Excluído com sucesso!' });
            } else {
                setStatus({ type: 'error', message: 'Erro ao excluir!' });
            }
            // let config = {
            //     method: 'delete',
            //     maxBodyLength: Infinity,
            //     url: `${apiUrl}/api/deals/${deal.id}/`,
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // };
            // const response = await axios
            //     .request(config)
            //     .then((response) => {
            //         console.log(JSON.stringify(response.data));
            //         if (onSaved) onSaved();
            //     })
            //     .catch((error) => {
            //         console.log(error);
            //     });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        // <Box>
        //     <Typography variant="h6" gutterBottom>
        //         Adicionar Canal
        //     </Typography>

        //     <TextField name="name" label="Nome" value={form.name} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
        //     <TextField name="type" label="Tipo" value={form.type} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
        //     <TextField name="external_id" label="ID externo" value={form.external_id} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
        //     <TextField
        //         name="description"
        //         label="Descrição"
        //         value={form.description}
        //         onChange={handleChange}
        //         fullWidth
        //         multiline
        //         rows={4}
        //         sx={{ mb: 2 }}
        //     />

        //     <Box display="flex" justifyContent="flex-end" gap={1}>
        //         <Button
        //             onClick={onClose}
        //             variant="contained"
        //             sx={{
        //                 backgroundColor: '#6faba0',
        //                 textTransform: 'none'
        //             }}
        //         >
        //             Fechar
        //         </Button>

        //         <Button
        //             onClick={save}
        //             variant="contained"
        //             disabled={saving}
        //             sx={{
        //                 backgroundColor: '#32CD32',
        //                 textTransform: 'none'
        //             }}
        //         >
        //             Salvar
        //         </Button>
        //     </Box>
        // </Box>
        <Box>
            <Typography variant="h5" gutterBottom sx={{ mb: 2, top: 5, right: 10, left: 20, position: 'relative' }}>
                Criar Ticket
            </Typography>

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            <IconButton onClick={onClose} sx={{ position: 'absolute', top: 10, right: 10 }}>
                <CloseIcon />
            </IconButton>

            <Card>
                <CardContent>
                    {/* {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2 }}>
                            {status.message}
                        </Alert>
                    )} */}

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            {/* Nomes */}
                            <Grid item xs={12} sm={6}>
                                <TextField name="name" label="Nome" fullWidth value={form.name} onChange={handleChange} required />
                            </Grid>
                            {/* Role */}
                            <Grid item xs={12} sm={6}>
                                <TextField name="type" select label="Tipo" fullWidth value={form.type} onChange={handleChange}>
                                    <MenuItem value="whatsapp">WhatsApp</MenuItem>
                                    <MenuItem value="messenger">Messenger</MenuItem>
                                    <MenuItem value="email">E-mail</MenuItem>
                                    <MenuItem value="chat">Chat Web</MenuItem>
                                    <MenuItem value="api">Integração API</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="external_id"
                                    label="ID"
                                    fullWidth
                                    value={form.external_id}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            {/* Buttons */}
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button variant="outlined" color="secondary" onClick={onClose}>
                                        Voltar
                                    </Button>

                                    <Button type="submit" variant="contained" sx={{ backgroundColor: '#32CD32' }}>
                                        Salvar
                                    </Button>
                                </Box>
                            </Grid>{' '}
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ChannelDrawerCreate;
